<h1 class="text-center m-2">Link {{ ssoLoginName }} to User</h1>
<p class="m-2 text-center">Enter your Company and Employee Number below to receive a PIN via text or email associated with your Employee User.</p>
<form *ngIf="!verified" [formGroup]="verifyUserForm" (ngSubmit)="verifyUser()" class="w-100 h-100 mt-2">
    <div *ngIf="companySelection.isSelection" class="m-2">
        <app-company-input [isDropdown]="companySelection.isDropdown"
                           [companies]="companySelection.companies"
                           formControlName="companySelect">
        </app-company-input>
    </div>
    <div class="m-2">
        <label for="employee-num">Employee Number<span class="text-danger font-weight-bolder h3"> *</span></label>
        <input #employeeNum type="number" class="form-control" id="employee-num" name="employee-num" required formControlName="employeeNum" />
    </div>
    <div class="m-2 mt-3 mb-3">
        <button [disabled]="verifyUserForm.invalid" class="btn btn-primary w-100" type="submit">Verify</button>
    </div>
</form>

<form *ngIf="verified" [formGroup]="userLinkForm" (ngSubmit)="linkUser()" class="w-100 h-100 mt-2">
    <div *ngIf="companySelection.isSelection" class="m-2">
        <app-company-input [isDropdown]="companySelection.isDropdown"
                           [companies]="companySelection.companies"
                           [isDisabled]="true"
                           formControlName="companySelect">
        </app-company-input>
    </div>
    <div class="m-2">
        <label for="employee-num">Employee Number<span class="text-danger font-weight-bolder h3"> *</span></label>
        <input #employeeNum type="number" class="form-control" id="employee-num" name="employee-num" required formControlName="employeeNum"/>
    </div>
    <div class="m-2">
        <p class="mt-2 mb-0">Enter the PIN you received via text or email</p>
        <label for="pin">PIN<span class="text-danger font-weight-bolder h3"> *</span></label>
        <input class="form-control" type="text" id="pin" formControlName="pin" required />
    </div>
    <div class="m-2 mt-3 mb-3">
        <button [disabled]="userLinkForm.invalid" class="btn btn-primary w-100" type="submit">Link User</button>
    </div>
</form>